"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
require("./Toggle.css"); // Import the CSS file for styling
var Toggle = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, themeMode = _a.themeMode, style = _a.style, defaultChecked = _a.defaultChecked, _b = _a.size, size = _b === void 0 ? 'small' : _b;
    return (react_1.default.createElement(antd_1.Switch, { checked: checked, onChange: onChange, size: size, defaultChecked: defaultChecked, className: "".concat(themeMode, "-toggle"), style: style }));
};
exports.default = Toggle;
